exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new_week_title{font-size:19px;font-weight:700;color:#f8bd39;margin-top:15px;margin-bottom:15px}", ""]);

// exports
